import React from 'react';
import '../css/loader.css';

export const Loading = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Loading.js